export default __webpack_public_path__ + "static/media/photo.0da0cdb3.svg";